// extracted by mini-css-extract-plugin
module.exports = {"Snippet":"jq_a bgu_rk"};